import type { SavingSettingsDetailsConfig } from './SavingSettingsDetailsConfig';

export const settingsDetails: SavingSettingsDetailsConfig = {
    creditInterestRateTooltipHuSpecificTranslation: false,
    shouldDisplayCreditInterestRateWithTooltip: false,
    shouldDisplayIBANWithTooltip: false,
    displayDisposableBalance: false,
    averageSavings: {
        displayAccountOwner: false,
        displayIban: false,
        displaySlashedBBAN: false,
        displayDashedBBAN: false,
        displaySpacedBBAN: false,
        displayPlainAccountNumber: false,
        displayBIC: false,
    },
    termDeposit: {
        displayAccountOwner: false,
        displayIban: false,
        displaySlashedBBAN: false,
        displayDashedBBAN: false,
        displaySpacedBBAN: false,
        displayPlainAccountNumber: false,
        displayBIC: false,
    },
    passbook: {
        displayAccountOwner: false,
        displayIban: false,
        displaySlashedBBAN: false,
        displayDashedBBAN: false,
        displaySpacedBBAN: false,
        displayPlainAccountNumber: false,
        displayBIC: false,
    },
    showAccountProhibitions: false,
    displayProductTerm: false,
    displayCreditInterestRateToDate: false,
    displayCreditInterestRatePeriod: false,
    displayDebitInterestRate: false,
    displayDebitInterestRatePeriod: false,
    displayFees: false,
};
